import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import Modal from 'react-bootstrap/Modal';
import DateConverter from '../Tools/DateConverter';
import { jsPDF, Rectangle } from "jspdf";
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function ReporteRetrasos() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [alcances, setAlcances] = useState([]);
    const [elegido, setElegido] = useState(0);
    const [filtroFecha, setFiltroFecha] = useState('');
    const [colaboradores, setColaboradores] = useState([]);
    const [modalSelector, setModalSelector] = useState(false);
    const [modalInfo, setModalInfo] = useState(false);
    const [subAlcance, setSubAlcance] = useState(0);
    const [listaSubAlcance, setListaSubAlcance] = useState([]);
    const [infoSelecE, setInfoSelecE] = useState({});
    const buscarRetrasos = () => {
        setColaboradores([]);
        setLoading(true);
        var regional = JSON.parse(localStorage.getItem('__react_session__')).regional
        if (filtroFecha !== '') {
            fetch(`${server}/reporte/retrasos`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, elegido, filtroFecha, subAlcance
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.ok) {
                        setColaboradores(data.ok);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        }
    }
    const elegirAlcance = (e) => {
        var valor = parseInt(e.target.value);
        console.log(valor);
        if (valor == 2 || valor == 0 || valor == 1) {
            setElegido(e.target.value);
        } else {
            setElegido(e.target.value);
            var info = alcances.filter(item => item.ID_ALCANCE === valor)[0].info;
            console.log(info);
            setListaSubAlcance(info);
            setModalSelector(true);
        }
    }
    const infoEmpleado = async (empleado) => {
        console.log(empleado);
        var regional = JSON.parse(localStorage.getItem('__react_session__')).regional;
        fetch(`${server}/reporte/getHorasTrabajadas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional,
                anio: new Date(filtroFecha).getFullYear(),
                mes: new Date(filtroFecha).getMonth() + 1,
                idEmpleado: empleado.ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.ok) {
                    var ingreso = data.ok.filter((item) => item.TIPO === 'I');
                    var salida = data.ok.filter((item) => item.TIPO === 'S');
                    var sumaHoras = 0;
                    for (var i = 0; i < salida.length; i++) {
                        sumaHoras = sumaHoras + Math.round((new Date(salida[i].HORA).getTime() - new Date(ingreso[i].HORA).getTime()) / 3600000);
                    }
                    setInfoSelecE({ ...empleado, sumaHoras });
                    setModalInfo(true);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function calcularTiempo(horaC, horaR) {
        if (horaC === null || horaR === null) {
            return "Inconcistencia"
        } else {
            var horaContrato = horaC.split('/');
            var horaRegistro = horaR.split('/');
            var diferencia = Math.round((new Date(horaRegistro[0]).getTime() - new Date(horaContrato[0]).getTime()) / 60000);
            return diferencia;
        }
    }
    function sacarEntrada(contrato, tipo) {
        if (contrato != null) {
            var info = contrato.split('/');
            if (tipo === 0) {
                if (info.length > 2) {
                    return DateConverter.formatoHora(info[0]) + ' - ' + DateConverter.formatoHora(info[2]);
                } else {
                    return DateConverter.formatoHora(info[0]);
                }
            } else {
                if (info.length > 2) {
                    return DateConverter.formatoHora(info[1]) + ' - ' + DateConverter.formatoHora(info[3]);
                } else {
                    return DateConverter.formatoHora(info[1]);
                }
            }
        }
    }
    function generarPdf() {
        if (colaboradores.length != 0) {
            const doc = new jsPDF({
                orientation: 'p',
                unit: 'mm',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16 // or "smart", default is 16
            });
            var tamH = doc.internal.pageSize.height;
            var tamW = doc.internal.pageSize.width;
            var x = 10
            var y = 10;
            doc.setFontSize(12);
            //doc.rect(5, 5, 200, 287, 'S');//margen 
            doc.line(x, y + 2, tamW - x, y + 2, 'S');
            doc.text('Colaborador', x, y);
            doc.text('Cargo', x + 60, y);
            doc.text('Sucursal', x + 100, y);
            doc.text('Departamento', x + 130, y);
            doc.text('Retraso', x + 175, y);
            y += 7;
            doc.setFontSize(7);
            for (var col of colaboradores) {
                if (col.CARNET_SEXO == 'F') {
                    doc.setTextColor(255, 87, 51);
                } else {
                    doc.setTextColor(10, 66, 185);
                }
                doc.text(col.NOMBREX.substring(0, 24) + '...', x, y);
                doc.text(col.CARGO.substring(0, 18) + '..', x + 60, y);
                doc.text(col.SUCURSAL, x + 100, y);
                doc.text(col.DEPARTAMENTO, x + 130, y);
                var retraso = calcularTiempo(col.HORA_CONTRATO, col.HORA_REGISTRO)
                doc.text(retraso == 'Inconcistencia' ? '' : retraso.toString(), x + 180, y);
                doc.line(x, y + 2, tamW - x, y + 2, 'DF');
                y += 7
                if (y >= tamH - 10) {
                    doc.addPage();
                    x = 10;
                    y = 10;
                }
            }
            var fecha = new Date();
            doc.save(fecha.toLocaleString() + "retrasos.pdf");
        }
    }
    function buscarColaborador() {
        var input, filter, cuadro, tr, td, i, txtValue;
        input = document.getElementById("buscarColaborador");
        filter = input.value.toUpperCase();
        cuadro = document.getElementById("listaBuscar");
        tr = cuadro.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("div")[2];
            if (td) {
                txtValue = td.innerHTML;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    useEffect(() => {
        if (filtroFecha === '') {
            setFiltroFecha(new Date().toISOString().substring(0, 10))
        }
        var regional = JSON.parse(localStorage.getItem('__react_session__')).regional
        fetch(`${server}/comunicados/lista/alcances`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data.ok);
                setAlcances(data.ok);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [])
    return (
        <div>
            <div className='container-fluid bg-dark bg-gradient py-1' style={{paddingRight:'50px'}}>
                <div className='btn-group'>
                    <div className='row row-cols gx-1 g-1'>
                        <div className='col' style={{ minWidth: '140px', maxWidth: '160px' }}>
                            <div className="input-group input-group-sm my-auto" >
                                <span className="input-group-text bg-secondary bg-gradient text-light" >Filtrar</span>
                                <select className=" form-select text-center "
                                    value={elegido} onChange={elegirAlcance}
                                >
                                    <option value='0'>Todos</option>
                                    <option value='1'>Oficinas</option>
                                    {alcances.map((item) => {
                                        if (item.ID_ALCANCE !== 3 && item.ID_ALCANCE !== 5 && item.ID_ALCANCE !== 7 && item.ID_ALCANCE !== 8) {
                                            return (<option key={item.ID_ALCANCE} value={item.ID_ALCANCE}>{item.DESCRIPCION}</option>)
                                        }
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className='col' style={{ minWidth: '140px', maxWidth: '160px' }}>
                            <div className="input-group input-group-sm my-auto">
                                <span className="input-group-text bg-secondary bg-gradient text-light my-auto">Fecha</span>
                                <input type="date" className="form-control modificado" value={filtroFecha} onChange={(e) => setFiltroFecha(e.target.value)}
                                    aria-describedby="basic-addon1" id="fechaGrafica" />
                            </div>
                        </div>
                        <div className='col' style={{ maxWidth: '90px',minWidth:'90px' }}>
                            <button className='btn btn-sm btn-secondary w-100'
                                onClick={buscarRetrasos}
                            >
                                <i className="fa-solid fa-magnifying-glass"></i> Buscar
                            </button>
                        </div>
                        {colaboradores.length !== 0 && <div className='col' style={{ maxWidth: '90px',minWidth:'90px' }}>
                            <button className='btn btn-sm btn-warning w-100' onClick={() => generarPdf()}>
                                <i className="fa-regular fa-file-pdf"></i> Pdf
                            </button>
                        </div>}
                        {colaboradores.length !== 0 && <div className='col' style={{ maxWidth: '130px', minWidth: '130px' }}>
                            <input type="text" className="form-control form-control-sm" placeholder='Buscar Colaborador'
                                id='buscarColaborador' onChange={() => buscarColaborador()} />
                        </div>}
                    </div>
                </div>
            </div>
            <div className='table-responsive '>
                <div className='table table-sm table-striped table-hover table-bordered border-secondary border-gradient' id='listaBuscar'>
                    <thead className='bg-dark bg-gradient text-light text-center'>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Sucursal</th>
                            <th scope="col">Departamento</th>
                            <th scope='col'>Retraso</th>
                            <th scope='col'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {colaboradores.map((item) => {
                            var diferencia = calcularTiempo(item.HORA_CONTRATO, item.HORA_REGISTRO);
                            if (diferencia > 0 || diferencia == "Inconcistencia") {
                                return (
                                    <tr key={item.ID_EMPLEADO}>
                                        <td className='col-4'>
                                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }} >
                                                {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                                <div className='ps-2 my-auto d-none d-sm-inline'>
                                                    <div className="cargoHeader fw-bold" id='buscareAqui'>{item.NOMBREX}</div>
                                                    <div className='cargoHeader '>{item.CARGO}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='col-1'>{item.SUCURSAL}</td>
                                        <td className=''>{item.DEPARTAMENTO}</td>
                                        <td className='col-1 text-center'>{diferencia != 'Inconcistencia' ? diferencia + " [min]" : diferencia}</td>
                                        <td className='col-1 text-end'>
                                            <button className='btn btn-sm btn-secondary btn-gradient'
                                                onClick={() => infoEmpleado(item)}>
                                                <i className="bi bi-info-circle-fill"></i><span className='d-none d-none d-md-inline'> Detalle</span>
                                            </button>
                                        </td>
                                    </tr>)
                            }
                        })}
                    </tbody>
                </div>
            </div>
            <Modal show={modalSelector} onHide={() => setModalSelector(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='modalNuevoC'>
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar una Opción</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='forms-inputs'>
                        <select className="form-select btn btn-secondary" value={subAlcance}
                            onChange={(e) => { setSubAlcance(e.target.value); setModalSelector(false) }}>
                            <option value={-1}>Ninguno</option>
                            {listaSubAlcance.map((item) => {
                                return (
                                    <option value={item.ID} key={item.ID} >{item.NOMBRE}</option>
                                )
                            })}
                        </select>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={modalInfo} onHide={() => setModalInfo(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant="white">
                    <div className="card bg-transparent flex-row m-0 p-0 text-light" style={{ border: 'none' }}>
                        {UtilsBufer.getFotoCard(infoSelecE.FOTO, 40)}
                        <div className='ps-2 my-auto'>
                            <div className="cargoHeader fw-bold">{infoSelecE.NOMBREX}</div>
                            <div className='cargoHeader '>{infoSelecE.CARGO}</div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container-fluid text-light'>
                        <div className='row row-cols-1 row-cols-md-3 g-1'>
                            <div className='col col-md-5'>
                                <div className="fw-bold">Hora Contrato</div>
                                <div>
                                    Entrada: {sacarEntrada(infoSelecE.HORA_CONTRATO, 0)}
                                </div>
                                <div>
                                    Salida: {sacarEntrada(infoSelecE.HORA_CONTRATO, 1)}
                                </div>
                            </div>
                            <div className='col col-md-5'>
                                <div className="fw-bold">Hora Registrado</div>
                                <div>
                                    Entrada: {sacarEntrada(infoSelecE.HORA_REGISTRO, 0)}
                                </div>
                                <div>
                                    Salida: {sacarEntrada(infoSelecE.HORA_REGISTRO, 1)}
                                </div>
                            </div>
                            <div className='col col-md-2'>
                                <div className='fw-bold'>
                                    Horas Mes
                                </div>
                                <div>{infoSelecE.sumaHoras} [Hrs]</div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ReporteRetrasos
